import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';
/* eslint-disable */
import './index/hotel.css';
import '@/css/desktop/tooltip.scss';
import "./index/pageTopBlock/mentionsBlock/mentionsBlock.css";
import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";
import HotelPageView from './index/HotelPageDistributed';
import HotelPageGalleryView from './index/pageTopBlock/gallery/gallery';
import HotelPageReviewsView from './index/reviews/HotelPageReviews';
import hotelPageGAEventsView from "@/js/desktop/components/hotelPageGAEvents/hotelPageGAEvents";
import getTopHOtelsAvailable from '@/js/common/services/getTopHOtelsAvailable';
import { initAdModal } from '@/js/common/services/promoService';
import CookieConsentView from '@/js/desktop/components/cookieConsent/CookieConsent';

var Controller = Backbone.View.extend({
	view: null,
	initModels: function() {
		this.dataLayerAnalytics = new DataLayerAnalytics({
			step: "hotelPage",
			maxStep: 2
		});

		this.view = new HotelPageView({
			el: 'body',
			hotelInfo: window.appConfig.hotelInfo,
			dataLayerAnalytics: this.dataLayerAnalytics
		});

		HotelPageGalleryView.init();

		$(".similar-hotel__carousel").jsCarousel();
		new HotelPageReviewsView();

		hotelPageGAEventsView.init();

		new CookieConsentView({
			el: '#cookieConsentContainer'
		});
	},
	hideTopHotels() {
		const isTopHotelAvailble = getTopHOtelsAvailable();
		if (isTopHotelAvailble) return;

		const topHotelsBlock = document.querySelector('.mentionsBlock');
		if(topHotelsBlock) {
			topHotelsBlock.style.display = 'none';
		}

	},
	initialize: function() {
		this.initModels();
		this.hideTopHotels();
		initAdModal();
    },
});

$(()=> {
	new Controller({
		el: 'body'
	});
});
